import type { FC, Ref } from "react";
import { FAQItem } from "@huub-web/shared";

export type FAQItemTemplateProps = {
  record: {
    title: string;
    slug: string;
    summary: string;
    content: string;
  };
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * FAQItemTemplate displays a single FAQ item with full content.
 */
export const FAQItemTemplate: FC<FAQItemTemplateProps> = ({ record, ref }) => (
  <FAQItem record={record} ref={ref} />
);
